import { StyledTag } from './StatusTagStyles';
import { AdminStatus } from '@/models/admins.model';
import { useTranslation } from 'react-i18next';

type ITagProps = {
  status?: AdminStatus;
};

const StatusTag = ({ status }: ITagProps) => {
  const { t } = useTranslation(['common']);

  return <StyledTag $status={status}>{t(`user_statuses_${status}`)}</StyledTag>;
};

export default StatusTag;
